// TODO: fix max-len eslint issues
/* eslint-disable max-len */
import React, { useState } from 'react';
import reactStringReplace from 'react-string-replace';

import {
    Anchor,
    FormField,
    FormHelp,
    Label,
    Text,
    Textarea,
    Spacer,
} from '@zillow/constellation';
import { Link } from '@zillow/zrs-comet';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

const writingTipsURL = 'https://www.zillow.com/rental-manager/resources/how-to-write-a-rental-ad/#description';

const DetailedDescription = (props) => {
    const {
        descriptionRef,
        errorObj,
        formData,
        isInputFormDisabled,
        savePropertyData,
        updateFormData,
        updateOnFocus,
    } = props;

    const [detailedDescription, setDetailedDescription] = useState(formData.description);
    const [leaseTerms, setLeaseTerms] = useState(formData.leaseTerms);
    const { localeSpecificNotice } = formData;

    const renderWithReplacedLinks = () => {
        const { text, mappings } = localeSpecificNotice;
        let formattedText;

        mappings.forEach((item) => {
            const { replaceUrl, replaceText } = item;

            // replace with link component
            formattedText = reactStringReplace(text, replaceText, () => (
                <Link
                    type="secondary"
                    to={replaceUrl}
                    target="_blank"
                >
                    {replaceText}
                </Link>
            ));
        });
        return formattedText;
    };

    return (
        <div className="DetailedDescription">
            <Text fontType="h4">Detailed description</Text>
            <Spacer marginBottom="sm" />
            <div ref={descriptionRef} />
            <FormField marginBottom="sm">
                <Label>About the property</Label>
                <Text fontType="smallbody" as="p">
                    Renters will read this first, so highlight any upgrades and desirable features. This article has more tips on
                    <Anchor target="_blank" href={writingTipsURL}> what to include.</Anchor>
                </Text>
                <Spacer marginBottom="xs" />
                <Textarea
                    aria-label="Description"
                    autosize={true}
                    disabled={isInputFormDisabled}
                    error={errorObj.description}
                    resize="both"
                    name="description"
                    placeholder="Ex: Freshly painted home with new appliances and carpeting. Easy walking to public transit and a great neighborhood."
                    value={detailedDescription}
                    onChange={e => setDetailedDescription(e.target.value)}
                    onFocus={() => updateOnFocus('description', formData.description)}
                    onBlur={(e) => {
                        updateFormData({ description: detailedDescription });
                        savePropertyData(
                            'description',
                            e.target.value,
                            {
                                componentGroupName:
                        AnalyticsConstants.LISTING_COMPONENT_GROUP_NAME.DETAILS_DESCRIPTION,
                            }
                        );
                    }}
                />
                {errorObj.description && (
                    <FormHelp error={true}>
                        {errorObj.description}
                    </FormHelp>
                )}
            </FormField>
            <FormField marginBottom="sm">
                <Label>Lease summary</Label>
                <Text fontType="smallbody" as="p">
                    Share details that can be deal breakers &mdash; or deal makers &mdash; for renters. Be up front about fees and utility costs. Also include your pet, smoking, and parking policies.
                </Text>
                <Spacer marginBottom="xs" />
                <Textarea
                    aria-label="Lease summary"
                    autosize={true}
                    error={errorObj.leaseTerms}
                    label="Lease summary"
                    resize="both"
                    name="Lease summary"
                    onBlur={(e) => {
                        updateFormData({ leaseTerms });
                        savePropertyData(
                            'leaseTerms',
                            e.target.value,
                            {
                                componentGroupName:
                                AnalyticsConstants.LISTING_COMPONENT_GROUP_NAME.DETAILS_DESCRIPTION,
                            }
                        );
                    }}
                    placeholder="Ex: Owner pays for water. Renter responsible for gas and electric. Last month's rent due at signing. No smoking allowed. Up to two small pets permitted."
                    value={leaseTerms}
                    onChange={e => setLeaseTerms(e.target.value)}
                    onFocus={() => updateOnFocus('leaseTerms', formData.leaseTerms)}
                    disabled={isInputFormDisabled}
                />
            </FormField>
            {localeSpecificNotice && (
                <Text data-testid="localSpecificNotice" fontType="smallbody">
                    <em>{renderWithReplacedLinks()}</em>
                </Text>
            )}
            <Spacer marginY="md" />
        </div>
    );
};

export { DetailedDescription };
